import $ from 'jquery'
import postContentSize from './content_size'

$("#statistic_card_title").on("change keyup paste", function(){
  defaultStatisticCardHandler("statistic_card_title");
});

function defaultStatisticCardHandler(field_name){
  var decision_helper_id = $('#decision_helper_id').val()
  var field_value = $('#'+field_name).val()
  var fields = {}
  fields[field_name] = field_value
  postContentSize(field_name, "/content_size/statistic_card", { decision_helper_id: decision_helper_id, field_name: field_name, fields: fields })
  .done(function( data ) {
    if(data["valid"]) {
     $("#"+field_name+"_error").hide()
    } else {
      $("#"+field_name+"_error").show()
    }
  });
}